import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import Container from 'ls-common-client/dist/components/Container';
import Header from '../../components/NewHeader';
import AddABusiness from '../../components/AddABusiness';
import ReviewForm from '../../components/ReviewForm';
import UserLogin from '../../components/UserManagement/UserLogin';
import { Context } from '../../context/AppContext';
import Enquiries from './Enquiries';

const UserEnquiries = () => {
  const {
    auth,
    media: { mobile },
  } = useContext(Context);

  return (
    <Container>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container>
        <Header showSearch />
        <Container
          maxWidth="1300px"
          minHeight={mobile ? 'unset' : '800px'}
          margin="auto"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {auth.token() ? <Enquiries /> : <UserLogin type="enquiries" />}
        </Container>
      </Container>
      <AddABusiness />
      <ReviewForm />
    </Container>
  );
};

export default UserEnquiries;
